// =============================================================================
// FILE:
// frontend/src/pms/task_execution/components/TaskExecutionKPISection.js
// =============================================================================

import React from "react";


// =============================================================================
// COMPONENT
// =============================================================================

export default function TaskExecutionKPISection({

  kpis = {}

}) {

  const cards = [

    {
      label: "Assigned Tasks",
      value:
        kpis.assigned_tasks || 0,
      color: "#2563eb",
      icon: "📋"
    },

    {
      label: "Ready Tasks",
      value:
        kpis.ready_tasks || 0,
      color: "#16a34a",
      icon: "✅"
    },

    {
      label: "In Progress",
      value:
        kpis.in_progress_tasks || 0,
      color: "#ea580c",
      icon: "⚙️"
    },

    {
      label: "Blocked Tasks",
      value:
        kpis.blocked_tasks || 0,
      color: "#dc2626",
      icon: "⛔"
    },

    {
      label: "Completed Tasks",
      value:
        kpis.completed_tasks || 0,
      color: "#7c3aed",
      icon: "✔"
    }
  ];


  return (

    <div style={styles.grid}>


      {

        cards.map((card) => (

          <div
            key={card.label}
            style={{
              ...styles.card,

              borderTop:
                `4px solid ${card.color}`
            }}
          >

            <div>

              <div style={styles.label}>

                {card.label}

              </div>

              <div style={styles.value}>

                {card.value}

              </div>

            </div>


            <div style={styles.icon}>

              {card.icon}

            </div>

          </div>
        ))
      }

    </div>
  );
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  grid: {

    display: "grid",

    gridTemplateColumns:
      "repeat(auto-fit, minmax(220px, 1fr))",

    gap: 16,

    marginBottom: 20
  },

  card: {

    background: "#ffffff",

    borderRadius: 14,

    padding: 18,

    display: "flex",

    justifyContent: "space-between",

    alignItems: "center",

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  label: {

    fontSize: 13,

    color: "#6b7280",

    marginBottom: 8
  },

  value: {

    fontSize: 30,

    fontWeight: 700,

    color: "#111827"
  },

  icon: {

    fontSize: 28
  }
};